export var isRecordEmpty = function (record) {
    return Object.entries(record).length === 0 && record.constructor === Object;
};
